import { useState, useEffect } from 'react';

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&';

export default function GlitchText({
  text,
  className = '',
  speed = 40,
}: {
  text: string;
  className?: string;
  speed?: number;
}) {
  const [displayed, setDisplayed] = useState(text);
  const [glitching, setGlitching] = useState(false);

  useEffect(() => {
    let frame = 0;
    let interval: ReturnType<typeof setInterval>;

    const startGlitch = () => {
      frame = 0;
      setGlitching(true);
      interval = setInterval(() => {
        frame++;
        setDisplayed(
          text
            .split('')
            .map((char, i) => {
              if (char === ' ') return ' ';
              if (frame > i * 2) return char;
              return CHARS[Math.floor(Math.random() * CHARS.length)];
            })
            .join('')
        );
        if (frame >= text.length * 2) {
          clearInterval(interval);
          setDisplayed(text);
          setGlitching(false);
          setTimeout(startGlitch, 4000 + Math.random() * 3000);
        }
      }, speed);
    };

    const timeout = setTimeout(startGlitch, 800);
    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [text, speed]);

  return (
    <span
      className={className}
      style={{
        fontVariantNumeric: 'tabular-nums',
        filter: glitching ? 'drop-shadow(0 0 8px rgba(255,215,0,0.8))' : 'none',
        transition: 'filter 0.1s',
      }}
    >
      {displayed}
    </span>
  );
}
